import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service'
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-cf-type-manage-staff-popup',
  templateUrl: './cf-type-manage-staff-popup.component.html',
  styleUrls: ['./cf-type-manage-staff-popup.component.scss']
})
export class CfTypeManageStaffPopupComponent implements OnInit {
  form: any = {};
  bankList: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    public dialogRef: MatDialogRef<CfTypeManageStaffPopupComponent>,
    private appMasterService: AppMasterService,
    private dialog: MatDialog,
    private alertMessageService: AlertMessageService,
  ) {
    if (data) {
      this.form = data;
    } else {
      this.form.isActive = 'Y';
    }
  }
  ngOnInit(): void {
  }

  save() {
    if ((this.form.type !== undefined && this.form.type !== null && this.form.type !== "") && (this.form.description !== undefined && this.form.description !== null && this.form.description !== "")) {
      const data = {
        id: this.form.id,
        type: this.form.type,
        description: this.form.description,
        isActive: this.form.isActive
      };
      this.appMasterService.saveCfDocType(data).then((res: any) => {
        if (res === "error") {
          this.alertMessageService.open({message: "บันทึกข้อมูลไม่สำเร็จ", title:""});
        } else {
          this.dialogRef.close();
          this.alertMessageService.open({message: "บันทึกข้อมูลสำเร็จ", title:""});
        }
      });
    } else {
      this.alertMessageService.open({message: "กรุณากรอกข้อมูลให้ครบ", title:"ข้อผิดพลาด"});
    }
  }

  onChange(e) {
    if (e.checked == true) {
      this.form.isActive = "Y";
    } else {
      this.form.isActive = "N";
    }
  }

  endPopup(e) {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      disableClose: false,
      // width: '30vw',
      data: {
        header: e,
        button: 'close'
      },
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.dialogRef.close();
    });
  }

}
